import React from 'react';

import './facilitiesSVG.scss';

const FacilitiesSVG = ({ width, height }) => (
	<svg
		version="1.1"
		x="0px"
		y="0px"
		width={width || '52px'}
		height={height || '100px'}
		viewBox="72 0 10 150"
		xmlSpace="preserve"
		id="facilitiesSVG"
	>
		<g id="star" />
		<g id="circle2">
			<circle className="st0" cx="88.39" cy="18.93" r="8.35" />
		</g>
		<g id="circle3">
			<circle className="st0" cx="66.79" cy="20.26" r="8.35" />
		</g>
		<g id="circle1">
			<circle className="st0" cx="75.72" cy="37.72" r="8.35" />
		</g>
		<g id="body">
			<path className="st0" d="M65.9,51.75h21.74c0.88,0,1.52,0.82,1.32,1.68l-1.36,4.06l-0.08,27.35l20.67,45.57
		c1.67,3.75-1.07,7.97-5.17,7.97H49.07c-3.81,0-6.33-3.96-4.7-7.41l22.08-46.12l-0.33-27.19l-1.49-4.07
		C64.31,52.68,64.96,51.75,65.9,51.75z"/>
			<path className="st1" d="M74.11,74.8L74.11,74.8c-1.07,0-1.94-0.87-1.94-1.94v-10.6c0-1.07,0.87-1.94,1.94-1.94l0,0
		c1.07,0,1.94,0.87,1.94,1.94v10.6C76.05,73.93,75.18,74.8,74.11,74.8z"/>
			<path className="st1" d="M74.11,83.86L74.11,83.86c-1.07,0-1.94-0.87-1.94-1.94v-2.4c0-1.07,0.87-1.94,1.94-1.94l0,0
		c1.07,0,1.94,0.87,1.94,1.94v2.4C76.05,83,75.18,83.86,74.11,83.86z"/>
			<path className="st1" d="M62.95,105.63L62.95,105.63c0-1.07,0.87-1.94,1.94-1.94h22.42c1.07,0,1.94,0.87,1.94,1.94l0,0
		c0,1.07-0.87,1.94-1.94,1.94H64.88C63.81,107.57,62.95,106.7,62.95,105.63z"/>
			<path className="st1" d="M60.29,110.14h32.08l8.49,19.34c0.57,1.29-0.38,2.74-1.79,2.74H53.19c-1.43,0-2.37-1.48-1.78-2.77
		L60.29,110.14z"/>
		</g>
	</svg>

);

export default FacilitiesSVG;
